<template>
  <b-modal
    :visible="visible"
    :title="title"
    @hide="hide"
  >
    <div
      v-loading="loading"
      class="marketplaces-control"
    >
      <div class="row">
        <div class="col-6">
          <ul class="marketplaces-control-available">
            <li
              v-for="v in marketplaces"
              :key="v.id"
              @click="add(v.id)"
            >
              <div>{{ v.name }}</div>
              <div class="marketplaces-control__arrow marketplaces-control__arrow--right">
                <i class="fa fa-arrow-circle-right text-success" />
              </div>
            </li>
          </ul>
        </div>
        <div class="col-6">
          <ul>
            <li
              v-for="c in credentials"
              :key="c.id"
              @click="remove(c.id)"
            >
              <div>
                <i class="fa fa-arrow-circle-left text-danger" />
              </div>
              <div class="marketplaces-control__arrow">
                {{ c.name }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        {{ $t('Close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import MarketplaceCredentialsService from '../../services/MarketplacesCredentialsService';
import MarketplaceService from '../../services/MarketplacesService';

export default {
  name: 'AppMarketplaceCredentialsManageForAccountModal',
  props: {
    value: {
      type: Boolean,
    },
    accountId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: this.value,
      loading: true,
      marketplaces: [],
      credentials: [],
    };
  },
  computed: {
    title() {
      return `${this.$tc('Accounts', 1)} 2 / ${this.$tc('Marketplaces', 2)}`;
    },
  },
  watch: {
    value(v) {
      if (v === true) {
        this.load();
      }
      this.visible = v;
    },
  },
  methods: {
    load() {
      this.loading = true;
      MarketplaceCredentialsService.findByAccount(this.accountId).then(credentials => {
        this.credentials = credentials.map(e => ({
          name: e.marketplace.name,
          id: e.id,
          marketplaceId: e.marketplace.id,
        }));
        MarketplaceService.all().then(vendors => {
          this.marketplaces = vendors.map(e => ({ name: e.name, id: e.id })).filter(e => typeof this.credentials.find(c => c.marketplaceId === e.id) === 'undefined');
          this.loading = false;
        });
      }).catch(() => {
        this.$errors_showNetworkErrorMessage();
      });
      this.loading = false;
    },
    hide() {
      this.visible = false;
      this.$emit('input', false);
    },
    add(vendorId) {
      this.loading = true;
      MarketplaceCredentialsService.create(this.accountId, vendorId).then(() => {
        this.load();
        this.loading = false;
        this.$emit('updated');
      }).catch(e => {
        this.$toastr.error(e.message, this.$t('Error'));
        this.loading = false;
      });
    },
    remove(credentialsId) {
      // eslint-disable-next-line no-alert
      if (window.confirm(this.$t('Are you sure?'))) {
        this.loading = true;
        MarketplaceCredentialsService.remove(credentialsId).then(() => {
          this.load();
          this.$emit('updated');
          this.loading = false;
        }).catch(() => {
          this.$errors_showNetworkErrorMessage();
          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  .marketplaces-control {
    max-height: 70vh;
    overflow: hidden auto;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: .6rem;
        border: $gray-400 1px solid;
        margin-bottom: 5px;
        cursor: pointer;
        overflow: auto;

        div {
          float: left;
        }

        &:hover {
          background-color: $gray-100;
        }
      }
    }

    &__arrow {
      margin-left: 5px;

      &--right {
        margin-left: 0;
        margin-right: 5px;
        float: right !important;
      }
    }
  }
</style>
